import JSZip from 'jszip';
import axios from 'axios';
import { take, fork, all, put, call } from 'redux-saga/effects';
import { watchApiTask, apiTask } from 'app/sagas';
import { api } from 'app/api';
import { success, failure, request, action } from 'app/actions';
import { saveAs } from 'file-saver';
import * as actions from './simulatedEditionActions';
import cartaoRespostaExtra from './composingPDFs/CARTAO_RESPOSTA_EXTRA.pdf';
import neutralAnswersheet from './composingPDFs/CARTAO_NEUTRO_SAV.jpg';

export const checkCoordinatorPermissionEvaluationTask = watchApiTask(
  actions.CHECK_COORDINATOR_PERMISSION_EVALUATION,
  api.post,
  '/evaluation-system/checkCoordinatorPermission.php',
);

export const generateEvaluationAnswerSheetsFilesTask = watchApiTask(
  actions.GENERATE_EVALUATION_ANSWER_SHEET_FILES,
  api.post,
  '/evaluation-system/generateEvaluationAnswerSheetsFiles.php',
);

export const generateEvaluationAnswerSheetsFilesStatusTask = watchApiTask(
  actions.GENERATE_EVALUATION_ANSWER_SHEET_FILES_STATUS,
  api.post,
  '/evaluation-system/generateEvaluationAnswerSheetsFilesStatus.php',
);

export function* watchDownloadTask() {
  while (true) {
    const { payload } = yield take(actions.DOWNLOAD_PDF);
    yield put(action(request(actions.DOWNLOAD_PDF)));
    try {
      // console.log('Iniciando download do PDF...');
      // Baixar o arquivo ZIP inicial
      const { data } = yield call(
        api.post,
        '/evaluation-system/downloadEvaluationKit.php',
        payload,
        { responseType: 'blob' },
      );

      if (data && data instanceof Blob) {
        // console.log('Arquivo ZIP recebido, carregando...');

        // Carregar o ZIP usando JSZip
        const zip = yield JSZip.loadAsync(data);

        if (payload.schoolType === '2') {
          // URL of the neutral answersheet
          const neutralAnswersheetURL = neutralAnswersheet;

          // Download the additional PDF as an arraybuffer
          const imageResponse = yield call(axios.get, neutralAnswersheetURL, { responseType: 'arraybuffer' });

          if (imageResponse.headers['content-type'] !== 'image/jpeg') {
            throw new Error(
              'O conteúdo retornado não é um JPEG válido. Verifique a URL ou o servidor.',
            );
          }

          // Create Blob for the JPEG additional file
          const imageBlob = new Blob([imageResponse.data], { type: 'image/jpeg' });

          // Add image to ZIP
          zip.file('CARTAO_NEUTRO_SAV.jpg', imageBlob);
        } else {
          // URL do PDF na pasta public
          const pdfUrl = cartaoRespostaExtra;

          // Baixar o PDF adicional como arraybuffer
          // console.log('Lendo arquivo PDF adicional...');
          const pdfResponse = yield call(axios.get, pdfUrl, { responseType: 'arraybuffer' });
          // console.log('Status HTTP:', pdfResponse.status);
          // console.log('URL final:', pdfResponse.request.responseURL);
          // console.log('Conteúdo retornado:', pdfResponse.data);

          if (pdfResponse.headers['content-type'] !== 'application/pdf') {
            throw new Error(
              'O conteúdo retornado não é um PDF válido. Verifique a URL ou o servidor.',
            );
          }

          // Criar Blob para o PDF adicional
          // console.log('Criando Blob do PDF adicional...');
          const pdfBlob = new Blob([pdfResponse.data], { type: 'application/pdf' });

          // Adicionar o PDF ao ZIP
          zip.file('CARTAO_RESPOSTA_EXTRA.pdf', pdfBlob);
        }

        // console.log('Gerando novo arquivo ZIP...');
        const updatedZipBlob = yield zip.generateAsync({ type: 'blob' });

        // Salvar o arquivo ZIP
        // console.log('Salvando arquivo ZIP atualizado...');
        saveAs(updatedZipBlob, payload.filename);

        yield put(action(success(actions.DOWNLOAD_PDF)));
      } else {
        console.error('Erro: O dado recebido não é um Blob válido.');
        yield put(action(failure(actions.DOWNLOAD_PDF)));
      }
    } catch (error) {
      console.error('Erro ao fazer download do PDF:', error);
      yield put(action(failure(actions.DOWNLOAD_PDF)));
    }
  }
}

export const getEvaluationOnlineInProgress = apiTask(
  actions.GET_EVALUATION_ONLINE_IN_PROGRESS,
  api.post,
  '/evaluation-system/getEvaluationOnlineInProgress.php',
);

export const logDownloadEssayGuidelines = apiTask(
  actions.LOG_DOWNLOAD_ESSAY_GUIDELINES,
  api.post,
  '/evaluation-system/logDownloadEssayGuidelines.php',
);
export function* watchEvaluationOnlineInProgress() {
  while (true) {
    const { payload } = yield take(actions.GET_EVALUATION_ONLINE_IN_PROGRESS);
    yield fork(getEvaluationOnlineInProgress, payload);
  }
}

export function* watchLogDownloadEssayGuidelines() {
  while (true) {
    const { payload } = yield take(actions.LOG_DOWNLOAD_ESSAY_GUIDELINES);
    yield fork(logDownloadEssayGuidelines, payload);
  }
}

// Root module saga
export function* sagas() {
  yield all([
    fork(checkCoordinatorPermissionEvaluationTask),
    fork(watchDownloadTask),
    fork(generateEvaluationAnswerSheetsFilesTask),
    fork(generateEvaluationAnswerSheetsFilesStatusTask),
    fork(watchEvaluationOnlineInProgress),
    fork(watchLogDownloadEssayGuidelines),
  ]);
}
